// extracted by mini-css-extract-plugin
export default {"buttonCarousel":"ObservedOncocollections_buttonCarousel__UedV9","item":"ObservedOncocollections_item__VQI2M","title":"ObservedOncocollections_title__5qsyJ"};